import { useState } from "react";
import { isBrokerDealersOwnTransaction } from "../../../../../utils/amr-pipeline.utils";
import { AppState } from "../../../../../types/state/AppState";
import { useSelector } from "react-redux";
import { TransactionStatus } from "../../../../../types/amr-pipeline/enums/TransactionStatus";
import IconSVG from "../../../../../styles/svg-icons";
import { Transaction } from "../../../../../types/amr-pipeline/models/Transaction";

const localStorageKey = "closedShareTransactionBanners";

interface Props {
    transaction: Transaction;
    handleShare: () => void;
}

function BannerComponent({ transaction, handleShare }: Props) {
    const { userCompany } = useSelector(
        (state: AppState) => state.issuanceMonitor.amrPipelineCommon
    );
    const isOwnCompany = isBrokerDealersOwnTransaction(
        transaction,
        userCompany
    );
    const storedData = localStorage.getItem(localStorageKey);
    const closedBanners = storedData ? JSON.parse(storedData) : {};

    const [isClosed, setIsClosed] = useState(
        closedBanners[transaction.referenceName] || false
    );

    if (
        isClosed ||
        !isOwnCompany ||
        transaction.status !== TransactionStatus.Active
    ) {
        return null;
    }

    const handleCloseBanner = () => {
        setIsClosed(true);
        localStorage.setItem(
            localStorageKey,
            JSON.stringify({
                ...closedBanners,
                [transaction.referenceName]: true,
            })
        );
    };

    return (
        <div className="share-transaction-banner">
            <IconSVG name="info" width={16} height={16} />
            <span>
                Share the deal to start tracking views and engagement on the Analytics tab.
            </span>
            <button onClick={handleShare} className="btn btn-main btn-sm">
                Share
            </button>
            <button onClick={handleCloseBanner} className="btn-link btn-close-banner">
                <IconSVG name="close" width={16} height={16} />
            </button>
        </div>
    );
}

export function ShareTransactionBanner(props: Props) {
    return <BannerComponent key={props.transaction.referenceName} {...props} />;
}
